/**
 * Dual-Faced Card Indicator Component
 * 
 * Displays as a reverse card symbol overlay on dual-faced cards.
 * Indicates the card has an alternate face (for modal_dfc, transform, etc.)
 */
import React from 'react';
import { colors, spacing } from '../../styles/tokens';

interface DualFacedCardIndicatorProps {
  isFlipped?: boolean;
  onFlip?: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export const DualFacedCardIndicator: React.FC<DualFacedCardIndicatorProps> = ({
  isFlipped = false,
  onFlip,
}) => {
  return (
    <button
      onClick={onFlip}
      type="button"
      title={isFlipped ? "View front face" : "View reverse face"}
      style={{
        position: 'absolute',
        bottom: spacing.xs,
        right: spacing.xs,
        width: '32px',
        height: '32px',
        borderRadius: '50%',
        border: 'none',
        padding: 0,
        cursor: 'pointer',
        background: isFlipped 
          ? `linear-gradient(135deg, ${colors.info}, ${colors.primary})`
          : `linear-gradient(135deg, ${colors.warning}, ${colors.error})`,
        color: colors.white,
        fontSize: '16px',
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: `0 2px 8px rgba(0, 0, 0, 0.3)`,
        transition: 'all 0.2s ease-in-out',
        zIndex: 10,
      }}
      onMouseEnter={(e) => {
        (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1.15)';
        (e.currentTarget as HTMLButtonElement).style.boxShadow = `0 4px 12px rgba(0, 0, 0, 0.4)`;
      }}
      onMouseLeave={(e) => {
        (e.currentTarget as HTMLButtonElement).style.transform = 'scale(1)';
        (e.currentTarget as HTMLButtonElement).style.boxShadow = `0 2px 8px rgba(0, 0, 0, 0.3)`;
      }}
    >
      🔄
    </button>
  );
};
